import wixWindow from 'wix-window'; 
$w.onReady(function () { 
if (wixWindow.formFactor === "Mobile"){
let myLang = wixWindow.multilingual.currentLanguage;  
if (myLang === 'he') {
     $w('#specialtyHeb').expand();
     $w('#specialtyEng').collapse();
	 $w('#articles1').expand();
} else { 
     $w('#specialtyHeb').collapse();
     $w('#specialtyEng').expand();
	 $w('#articles1').collapse();
   }
} else {
	let myLang = wixWindow.multilingual.currentLanguage;  
if (myLang === 'he') {
     $w('#specialtyHeb').expand();
     $w('#specialtyEng').collapse();
	 $w('#articles1').expand();
} else { 
     $w('#specialtyHeb').collapse();
     $w('#specialtyEng').expand();
	 $w('#articles1').collapse();
}
}
});
